import React from "react";
import "./footer.css";
import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <div className="footer ottom-0 text-center">
      <Container>
        <span className="text-muted">Von Gonzales Portfolio 2025</span>
      </Container>
    </div>
  );
};

export default Footer;
